import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../shared";
import { VisitorPreferenceRequest } from "./Info/VisitorPreferenceRequest";

@Injectable()
export class DashboardVisitorService {
	constructor(private httpclientService: HttpclientService) {}

	FacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Dashboard/FacilitySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TodaysVisitorStatsSelect(FacilityID) {
		var postResult$ = new Subject();
		var url = "Dashboard/TodaysVisitorStatsSelect?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilityVisitorStatsSelect(FacilityID, OptionID) {
		var postResult$ = new Subject();
		var url = "Dashboard/FacilityVisitorStatsSelect?FacilityID=" + FacilityID + "&OptionID=" + OptionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictVisitorStatsSelect(OptionID) {
		var postResult$ = new Subject();
		var url = "Dashboard/DistrictVisitorStatsSelect?OptionID=" + OptionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeniedEntrySelectList(FacilityID) {
		var postResult$ = new Subject();
		var url = "Dashboard/DeniedEntrySelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	VisitorGraphOptionSelectList() {
		var postResult$ = new Subject();
		var url = "Dashboard/VisitorGraphOptionSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	VisitorGraphInfoSelectList() {
		var postResult$ = new Subject();
		var url = "Dashboard/VisitorGraphInfoSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	VisitorPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "Dashboard/VisitorPreferenceSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	VisitorPreferenceUpdate(parms: VisitorPreferenceRequest) {
		var postResult$ = new Subject();
		var url = "Dashboard/VisitorPreferenceUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
